import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    TabNav,
    TabNavItem,
} from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ResponsibleGamblingTabs.style';

export enum ResponsibleGamblingTabItemsRoute {
    DEPOSITLIMITS = 'deposit-limits',
    NETDEPOSITLIMITS = 'net-deposit-limits',
    SELFEXCLUSION = 'self-exclusion',
    PLAYBRAKE = 'play-break',
    REALITYCHECK = 'reality-check',
    COMPLIANCERESTRICTION = 'compliance-restriction',
    DEPOSITRESTRICTION = 'deposit-restriction',
    SRGQUESTIONS = 'srg-questions',
    MARKERSOFHARM = 'markers-of-harm',
    GAMPROTECT = 'gamprotect',
    GAMSTOP = 'gamstop',
    ACCOUNTCONFIG = 'account-config',
}
interface ResponsibleGamblingTabItemsPropsType {
    isSrgVisible: boolean;
    depositRestriction: boolean;
    isMarkersOfHarm: boolean;
    isGamprotectEnabled: boolean;
    isAccountConfigEnabled: boolean;
}

export const ResponsibleGamblingTabItems = observer(
    ({
        isSrgVisible,
        depositRestriction,
        isMarkersOfHarm,
        isGamprotectEnabled,
        isAccountConfigEnabled,
    }: ResponsibleGamblingTabItemsPropsType): JSX.Element | null => {
        const { routerBackoffice } = useAppStateContext();
        const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab') ?? 'deposit-limits';

        const isTabActive = (label: string): boolean => {
            return customerParams === label;
        };

        interface MenuItemsType {
            id: ResponsibleGamblingTabItemsRoute;
            label: string;
            onClick: () => void;
            isVisible: boolean;
        }

        const menuItems: Array<MenuItemsType> = [
            {
                id: ResponsibleGamblingTabItemsRoute.DEPOSITLIMITS,
                label: 'Deposit limits',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingDepositLimit(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.NETDEPOSITLIMITS,
                label: 'Net deposit limits',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingNetDepositLimit(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.SELFEXCLUSION,
                label: 'Self Exclusion',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingSelfExclusion(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.PLAYBRAKE,
                label: 'Play break',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingPlayBreak(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.REALITYCHECK,
                label: 'Reality Check',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingRealityCheck(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.COMPLIANCERESTRICTION,
                label: 'Compliance Restriction',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingComplianceRestriction(),
                isVisible: isSrgVisible,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.DEPOSITRESTRICTION,
                label: 'Deposit Restriction',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingDepositRestriction(),
                isVisible: depositRestriction,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.SRGQUESTIONS,
                label: 'SRG questions',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingSrgQuestions(),
                isVisible: isSrgVisible,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.MARKERSOFHARM,
                label: 'Interactions',
                onClick: (): void => routerBackoffice.redirectToCustomerMarkerOfHarm(),
                isVisible: isMarkersOfHarm,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.GAMPROTECT,
                label: 'Gamprotect',
                onClick: (): void => routerBackoffice.redirectToCustomerGamprotect(),
                isVisible: isGamprotectEnabled,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.GAMSTOP,
                label: 'Gamstop',
                onClick: (): void => routerBackoffice.redirectToCustomerGamstop(),
                isVisible: true,
            },
            {
                id: ResponsibleGamblingTabItemsRoute.ACCOUNTCONFIG,
                label: 'Account Config',
                onClick: (): void => routerBackoffice.redirectToCustomerResponsibleGamblingAccountConfig(),
                isVisible: isAccountConfigEnabled,
            },
        ];

        return (
            <TabNav data-test='responsible-gambling-category-tabs'>
                {menuItems.map(
                    (linkItem) =>
                        linkItem.isVisible && (
                            <TabNavItem
                                key={linkItem.id}
                                isActive={isTabActive(linkItem.id)}
                                onClick={linkItem.onClick}
                                value={linkItem.label}
                                data-test={`${linkItem.id}-tab`}
                            >
                                {linkItem.label}
                            </TabNavItem>
                        )
                )}
            </TabNav>
        );
    }
);
